import React, { useEffect } from 'react'
import { TextField, MenuItem } from '@material-ui/core'
import { useField } from 'formik'

const CustomSelect = ({
  showLabel = true,
  inputLabel,
  options,
  optionAttr,
  optionAttr2,
  handleChange,
  emptyFieldValue,
  ...props
}) => {
  const [field, meta] = useField(props)
  const errorText = meta.error && meta.touched ? meta.error : ''

  const handleOnChange = (event) => {
    field.onChange(event)
    handleChange && handleChange(event)
  }

  useEffect(() => {
    if (emptyFieldValue && options.length) {
      const existingOptionIndex = options?.findIndex((opt) => opt?.id === field?.value)
      if (existingOptionIndex < 0) {
        emptyFieldValue()
      }
    }
  }, [options])

  return (
    <TextField
      select
      variant="outlined"
      fullWidth
      label={showLabel ? inputLabel : ''}
      helperText={errorText}
      error={!!errorText}
      {...field}
      onChange={handleOnChange}
      {...props}>
      {!options?.length && (
        <MenuItem value="" disabled={true}>
          No data found.
        </MenuItem>
      )}
      {options?.map((o, index) => (
        <MenuItem value={o?.id} key={o?.id + index}>
          {optionAttr2 ? `${o[optionAttr]} - ${o[optionAttr2]}` : `${o[optionAttr]}`}
        </MenuItem>
      ))}
    </TextField>
  )
}

export default CustomSelect
